export const SET_MODAL = "SET_MODAL";

export const setModal = (modal) => ({type: SET_MODAL, modal});
